import classNames from "classnames";
import type { ComponentPropsWithRef } from "react";
// eslint-disable-next-line no-restricted-imports
import { Accordion as AccordionBase } from "@base-ui/react/accordion";
import styles from "./Accordion.module.scss";

export const AccordionRoot = <Value = string,>(
    props: AccordionBase.Root.Props<Value>,
) => <AccordionBase.Root {...props} />;

export const AccordionItem = ({
    className,
    ...props
}: ComponentPropsWithRef<typeof AccordionBase.Item>) => (
    <AccordionBase.Item className={className} {...props} />
);

export const AccordionHeader = ({
    className,
    ...props
}: ComponentPropsWithRef<typeof AccordionBase.Header>) => (
    <AccordionBase.Header
        className={classNames(styles.header, className)}
        {...props}
    />
);

export const AccordionTrigger = ({
    className,
    ...props
}: ComponentPropsWithRef<typeof AccordionBase.Trigger>) => (
    <AccordionBase.Trigger
        className={classNames(styles.trigger, className)}
        {...props}
    />
);

export const AccordionPanel = ({
    className,
    ...props
}: ComponentPropsWithRef<typeof AccordionBase.Panel>) => (
    <AccordionBase.Panel
        className={classNames(styles.panel, className)}
        {...props}
    />
);
